import React, { useEffect } from "react";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";
import { invalidateSession } from "../../common/InvalidateSession";

const AccessDeniedAsBevDisabled = (props) => {
  useEffect(() => {
    props.history.push("/denied");
    invalidateSession();
  }, []);

  return (
    <div className="pageWrapper">
      <div className={styles.brandDiv}>
        <FordLogo className={styles.brandLogo} />
      </div>
      <div className={styles.deniedTitle}>
        {props.t("AccessDeniedAsBevDisabled.header")}
      </div>
      <div className={styles.deniedInfo}>
        {props.t("AccessDeniedAsBevDisabled.subheader")}{" "}
        {props.t("AccessDeniedAsBevDisabled.help")}
      </div>
    </div>
  );
};

export default withTranslation("emp")(AccessDeniedAsBevDisabled);
